import styled, { css } from 'styled-components';

type Props = {
  $position?: 'left' | 'top' | 'bottom';
}

const Label = styled.label<Props>`
  display: inline-block;
  color: var(--color-text-secondary);
  ${({ $position }) => $position === 'top' && css`
    margin-bottom: 3px;
  `}
  ${({ $position }) => $position === 'bottom' && css`
    margin-top: 3px;
  `}
  ${({ $position }) => $position !== 'top' && $position !== 'bottom' && css`
    /* left is default position */
    margin-top: 3px;
  `}
`;

export default Label;
